import React, { useState } from "react";
import {
  chainstitchDetails,
  chainstitchError,
  chainstitchFields,
  MAX_LETTERS,
} from "../utils/chainstitch";
import ThreadPicker from "./ThreadPicker";
import { useLocation } from "react-router-dom";
import CartSummary from "./CartSummary";
import { useNavigate } from "react-router-dom";
import btnArrow from "../assets/img/section-btn-arrow.webp";
import useCartStore from "../api/cart";
import { NOTES_PLACEHOLDER } from "./PerfectFit";

const KnowMore = () => {
  const { cartItems, updateCartItem } = useCartStore();

  const [isOpen, setIsOpen] = useState(true);
  const [isOpen1, setIsOpen1] = useState(true);

  const toggleBox = () => {
    setIsOpen(!isOpen);
    setIsOpen1(!isOpen1);
  };

  const [selectedOptionPrice, setSelectedOptionPrice] = useState(() => {
    const savedOption = sessionStorage.getItem("optionprice");
    return savedOption || "";
  });

  const [repairLocation, setrepairLocation] = useState("");
  // Chainstitch asks for what is being stitched, which the notes box cannot
  // hold in a form anything could ever count. See utils/chainstitch.js.
  const [letters, setLetters] = useState("");
  const [design, setDesign] = useState("");
  const [thread, setThread] = useState("");
  // The cone off the studio wall, when they picked one. ThreadPicker.jsx.
  const [threadColor, setThreadColor] = useState(null);

  const location = useLocation();
  const selectedType = location.state?.selectedType || "";

  const [selectedPlan] = useState(() => {
    const savedPlan = sessionStorage.getItem("selectedPlan");
    return savedPlan || "";
  });

  const [selectedTask] = useState(() => {
    const savedTask = sessionStorage.getItem("selectedTask");
    return savedTask || "";
  });

  const [selectedOption] = useState(() => {
    const savedOption = sessionStorage.getItem("selectedOption");
    return savedOption || "";
  });

  const [notes, setNotes] = useState("");

  const navigate = useNavigate();

  let userData = JSON.parse(sessionStorage.getItem("userData"));

  const [errorInfo, setErrorInfo] = useState(null);
  // One screen for every task. A repair also says where; every task gets
  // the same "Notes to our tailors" box, saved as item_notes, which is what
  // the sticker, the order page and the QR page all read (2026-09-30:
  // repairs used to get "Repair Description" instead, which never reached
  // the sticker).
  const isRepair = sessionStorage.getItem("task") === "Repairing";
  // Which boxes chainstitch adds, if any: the letters for a name, the design
  // number for a design, the thread for anything stitched, nothing at all for
  // taking a pocket off. Null for every other kind of work.
  const serviceName = sessionStorage.getItem("option");
  const stitchFields = chainstitchFields(serviceName);
  const stitchAnswers = { letters, design, thread, threadColor };
  const chosenPiece = (() => {
    try {
      return JSON.parse(sessionStorage.getItem("selectedItems"));
    } catch {
      return null;
    }
  })();
  const handleApply = () => {
    if (isRepair && repairLocation.trim().length === 0) {
      setErrorInfo("Please enter details in the repair location box.");
      return;
    }
    // Not optional. Nobody can stitch a name that was not written down, and
    // none of it can be filled in afterwards.
    const stitchProblem = chainstitchError(serviceName, stitchAnswers);
    if (stitchProblem) {
      setErrorInfo(stitchProblem);
      return;
    }
    const note = notes.trim();
    // Every row this trip added, not just the first one. Three buttons
    // picked together on the service screen share one location and one note
    // (Alteration.jsx stamps each row it adds with the same `added_batch`).
    const batch = sessionStorage.getItem("addedBatch");
    const addedThisTrip = (service) =>
      (batch && service?.added_batch === batch) ||
      (service?.name === sessionStorage.getItem("option") &&
        chosenPiece?.id == service?.item_details?.id);
    const updatedServices = cartItems[0].services.map((service) => {
      if (addedThisTrip(service)) {
        return {
          ...service,
          ...(isRepair
            ? { repair_details: { location: repairLocation.trim() } }
            : {}),
          // Rides along on the service, so it lands in the job's
          // `service_details` with everything else and can be counted later.
          //
          // Merged, not replaced: the service screen already wrote where on
          // the garment it goes onto this same row (Alteration.jsx), and
          // this screen only knows the design and the thread.
          ...(chainstitchDetails(serviceName, stitchAnswers)
            ? {
                chainstitch_details: {
                  ...(service.chainstitch_details || {}),
                  ...chainstitchDetails(serviceName, stitchAnswers),
                },
              }
            : {}),
          ...(note ? { item_notes: note } : {}),
        };
      }
      return service;
    });
    updateCartItem(cartItems[0].id, {
      services: updatedServices,
    });
    navigate("/item-detail", { state: { data: location?.state?.data } });
  };

  return (
    <section className=" items-section same-bg-section relative">
      <div className="container padding-x-all">
        <div className="know-more-box sec-com-padding flex-box justify-between align-center">
          {[
            { className: "mobile-none", open: !isOpen },
            { className: "desktop-none", open: !isOpen1 },
          ].map((box) => (
            <CartSummary
              key={box.className}
              className={box.className}
              isOpen={box.open}
              onToggle={toggleBox}
            >
              <div className="show-box-list">
                <p className="show-box-para">This item</p>
                <h4 className="show-box-answer">
                  {sessionStorage.getItem("selectedItem")}
                </h4>
              </div>

              <div className="show-box-list">
                <p className="show-box-para">Plan</p>
                <h4 className="show-box-answer">
                  {sessionStorage.getItem("SelectedPlan")}
                </h4>
              </div>

              <div className="show-box-last-list">
                <p className="show-box-para">Task Detail</p>
                <h4 className="show-box-answer">
                  {sessionStorage.getItem("task")}
                </h4>
                <p className="show-box-para">
                  {sessionStorage.getItem("option")}
                </p>
                {selectedOptionPrice != "" && (
                  <div className="text-box">
                    <h4 className="show-box-answer">${selectedOptionPrice}</h4>
                  </div>
                )}
              </div>
            </CartSummary>
          ))}

          <div className="item-select-box">
            <h2>
              Is there anything else you would
              <br /> like for us to know?
            </h2>
            {stitchFields?.letters && (
              <div class="item-describe-box">
                <h5 class="describe-heading">
                  Letters to stitch (up to {MAX_LETTERS})
                </h5>
                <input
                  type="text"
                  class="know-more-description"
                  placeholder="e.g. Daisy"
                  maxLength={MAX_LETTERS}
                  value={letters}
                  onChange={(e) => setLetters(e.target.value)}
                />
              </div>
            )}
            {stitchFields?.designs && (
              <div className="item-describe-box">
                <h5 className="describe-heading">Design name</h5>
                {/* The name, not the number (Calley, 31 Oct 2026). A bare
                    number still works and is still checked against this
                    sheet's range, which is what catches a page 2 design rung
                    in on the page 1 line (utils/chainstitch.js). */}
                <input
                  type="text"
                  className="know-more-description"
                  placeholder={`e.g. Goose, or ${stitchFields.designs.first} to ${stitchFields.designs.last} off the sheet`}
                  maxLength={60}
                  value={design}
                  onChange={(e) => setDesign(e.target.value)}
                />
              </div>
            )}
            {stitchFields?.thread && (
              /* The cones in the studio, cotton and wool marked, with a box
                 underneath for a colour the wall does not have. A number
                 typed in that box is still read as a swatch off Natalie's
                 printed sheet (utils/chainstitch.js). */
              <ThreadPicker
                picked={threadColor}
                onPick={setThreadColor}
                typed={thread}
                onTyped={setThread}
              />
            )}
            {isRepair && (
              <div class="item-describe-box">
                <h5 class="describe-heading">Repair Location</h5>
                <textarea
                  class="know-more-description"
                  placeholder="eg. on the right elbow or along the seam"
                  maxLength={300}
                  value={repairLocation}
                  onChange={(e) => setrepairLocation(e.target.value)}
                ></textarea>
              </div>
            )}
            <div class="item-describe-box">
              <h5 class="describe-heading">Notes to our tailors (optional)</h5>
              <textarea
                class="know-more-description"
                placeholder={
                  isRepair
                    ? "e.g. Make the repair visible in red, or be careful of the lace trim."
                    : NOTES_PLACEHOLDER[location.state?.fitMethod] ||
                      "e.g. Take 2 inches off the hem, or be careful of the lace trim."
                }
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                maxLength={300}
              ></textarea>
            </div>
            {errorInfo && (
              <p
                className="para"
                style={{ fontWeight: "bold", fontSize: "0.8rem" }}
              >
                {errorInfo}
              </p>
            )}
            <button
              type="button"
              className={`mt-2-8 ${
                !isRepair || repairLocation.trim()
                  ? "section-main-btn"
                  : "section-main-btn1"
              }`}
              onClick={handleApply}
              disabled={isRepair && !repairLocation.trim()}
            >
              Next
              <span>
                <img src={btnArrow} alt="" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KnowMore;
